import { inject } from '@angular/core';
import { CanMatchFn, Router, Route, UrlSegment } from '@angular/router';
import { map } from 'rxjs';
import { Helpers } from './utils/helpers';

export const permissionMatchGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const helpers = inject(Helpers);
  const router = inject(Router);

  // ✅ Always treat permissions as string[]
  const requiredPermissions = (route.data?.['permissions'] ?? []) as string[];

  return helpers.hasPermission$(requiredPermissions).pipe(
    map((allowed) => {
      if (!allowed) {
        router.navigate(['/']); // ✅ redirect dashboard
        return false;
      }
      return true;
    })
  );
};
